export const CardApplicationType = {
  PREQUAL: 'PREQUAL',
  APPLY: 'APPLY',
} as const
